import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { MuiTabsBase } from '../../core/mui-tabs-base';
import { tabAnimation } from '../../core/tab-animation';
import { MuiTab } from '../tab/mui-tab.component';

@Component({
  selector: 'mui-tab-group',
  templateUrl: './mui-tab-group.component.html',
  styleUrls: ['./mui-tab-group.component.scss'],
  animations: [tabAnimation]
})
export class MuiTabGroup extends MuiTabsBase implements AfterContentInit {
  @ContentChildren(MuiTab)
  tabs: QueryList<MuiTab> = new QueryList<MuiTab>();

  currentTab: MuiTab | null = null;

  ngAfterContentInit(): void {
    if (this.tabs?.length > 0) {
      this.currentTab = this.tabs.first;
    }
  }

  setActiveTab(tab: MuiTab): void {
    this.currentTab = tab;
  }
}
